"use client";

import { useSignalREvent } from "@/lib/signalr/useSignalREvent";
import { SIGNALR_EVENTS } from "@/lib/signalr/events";
import type { CcofCardChangedEvent } from "@/lib/signalr/types";
import { useUpdatePatientSearchCache } from "@/features/patient/hooks/useUpdatePatientSearchCache";

export function useCommandPaletteCardChangedEvent(): void {
  const updatePatientSearchCache = useUpdatePatientSearchCache();

  useSignalREvent<CcofCardChangedEvent>(
    SIGNALR_EVENTS.CCOF_CARD_CHANGED,
    (event) => {
      if (!event.patient?.patientId) return;

      updatePatientSearchCache(event.patient.patientId, event.patient);
    },
  );
}
